/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */
import React, { ReactNode } from 'react'

import AssetTableCell from './AssetTableCell'
import { formatDate12, isNullOrUndefined } from './utils'

type DateColProps = {
  value: Date | null
}

const DateCol: React.FC<DateColProps> = ({ value }) => {
  const displayBlank = isNullOrUndefined(value)

  let displayValue: ReactNode = <div className="h-4 w-full flex"></div>
  if (!displayBlank) {
    displayValue = formatDate12(value)
  }

  return <AssetTableCell>{displayValue}</AssetTableCell>
}

export default DateCol
